import React, { Component } from 'react'
import axios from 'axios'
import { browserHistory } from 'react-router-dom'

class Termsconditions extends Component {


  constructor(props) {
    super(props)

    this.state = {
      checkme: '',
      clientID: '',
      payeeEmail: '',
      payeeName: '',
      entityName: '',
      requestID: ''
    }

  }
  componentWillMount() {
    var re = this.props.location.state.payeeName;
    console.log(re);

  }
  componentDidMount() {
    
    this.setState({ clientID: this.props.location.state.clientID });
    this.setState({ payeeEmail: this.props.location.state.payeeEmail });
    this.setState({ payeeName: this.props.location.state.payeeName });
    this.setState({ entityName: this.props.location.state.entityName });
    this.setState({ requestID: this.props.location.state.requestID });
   
  
  }
  changeHandler = (e) => {
    this.setState({ [e.target.name]: e.target.value })
  }


  // onChangeCheckBox(event) {
  //   if (event.target.checked) {
  //     this.actionButtonRef.disabled = "";
  //   }
  //   else {
  //     this.actionButtonRef.disabled = "disabled";
  //   }
  // }

  SendOTP() {  

   const AuthStr = 'A-Token '.concat(this.state.requestID); 
   const authAxios = axios.create({  
    baseURL: axios.defaults.authURL,
    headers: {         
        'Authorization': AuthStr
    },
   });

   const URL='Token/AuthenticateAuthCode?MFACode=&sendotp=true'  
   authAxios.post(URL) 


    // const URL = axios.defaults.baseURL + '/PayeePortal/SendOTP?requestID=' + this.state.requestID
    // axios.get(URL)

    let path = `/OTPVerify`;
    this.props.history.push(path,
      {
        requestID: this.state.requestID,
        payeeName: this.state.payeeName,
        entityName: this.state.entityName,
        clientID: this.state.clientID,
        payeeEmail: this.state.payeeEmail
      });
  }

  render() {                     
    return (
      <>
        <section id="wrapper">
          <div className="login-register" style={{ backgroundImage: "url(assets/images/back_AFX.png)" }}>
            <div className="lgtop"><img src="assets/images/afxlogo.png" /></div>
            <form>
              <div className="login-box1">

                <div>
                  <div style={{ fontSize: "14px", color: "#fff" }}>
                    <b>Welcome {this.state.payeeName},</b>
                    <br />
                    <br />

                    <p>Please read the terms and conditions below.</p>
                    <br />

                    <div class="overflow-auto" style={{ maxHeight: "180px", borderRadius: "5px", border: "1px solid #3fba8d", padding: "1rem", backgroundColor: "#fff", color: "#000" }}>
                      <p><b>Payee terms and conditions.</b></p>
                      <p>You have accessed the Apay Payee Portal using the secure login provided to you by AscendantFX Capital Inc. (“AFX” “We” or “Us”).</p>
                      <p>AFX has provided you the secure login by email at the direction of the debtor/payer identified in our email to you (“Payer”) who has requested AFX pay a receivable
&nbsp; &nbsp;<a style={{ color: "red" }} href="assets/TermsConditions.pdf" target="_blank">Read More...</a>
                      </p>
                    </div>

                  </div>

                  {/* <div className="d-flex no-block align-items-center m-t-50">
                    <div className="form-check">
                      <label className="form-check-label">
                        <input type="checkbox" ref={element => { this.checkboxAllRef = element; }}
                          onChange={event => this.onChangeCheckBox(event)} className="form-check-input" style={{ color: "#fff", opacity: 1 }} />
                        I agree to the terms and conditions.
                     </label>
                    </div>
                  </div> */}
                </div>

                <div className="form-group text-center m-t-20">

                  <div className="col-md-8 offset-md-2">                    
                    {/* <button className="btn btn-logs btn-lg btn-block text-uppercase waves-effect waves-light" style={{ cursor: "pointer" }} 
                    ref={element => { this.actionButtonRef = element;}}
                    onClick={() => { this.SendOTP() }}>I Agree</button> */}
<br/><br/>
                    <button className="btn btn-logs btn-lg btn-block text-uppercase waves-effect waves-light" style={{ cursor: "pointer" }} onClick={() => { this.SendOTP() }}>I Agree</button>
                  </div>
                </div>

              </div>
            </form>
          </div>
        </section>
      </>
    )
  }
}

export default Termsconditions
